// Re-export this here because it used to be here and I don't want
// to change imports too much.
export { Mode } from '../plugin';